export default __webpack_public_path__ + "static/media/export.6b9e15ea.svg";